var TAHeader = (function($) {
	'use strict';

	var _$header;
	var $windowWidth;
	var $menuParent;
	var $mainMenuTopLink, $mainMenuTopLinkSingle;
	var $mainMenuLvl2Lnk, $mainMenuLvl3Lnk;
	var $body;
	var $buttons;
	var $isMobileWidth;
	var $gformIntro;
	var $header;
	var $heroScroller;
	var $heroScrollerID;
	var $iconMenu;
	var $mobileMenu;
	var $prevScrollpos = window.pageYOffset;
	var debounce_timer;
	var $menuTracker;
	var $menuWrap;
	var $subMenu, $subMenuWrap;
	var $searchButton, $searchCloseButton, $searchWrapper;
	var $wrapperMenu, $utilityMenu;
	var $overlay;
	var $videoOverlay;
	var isOnScreen;
	var $card;
	
	function init() {

		$body = $('html, body');
		$header = $('header');
		$buttons = $('body a');
		$mainMenuTopLink = $('header .menu-main-nav > li.menu-item-has-children');
		$mainMenuTopLinkSingle = $('header .menu-main-nav > li');
		$mainMenuLvl2Lnk = $('header .menu-main-nav > li.menu-item-has-children ul > li.menu-item-has-children');
		$mainMenuLvl3Lnk = $('header .menu-main-nav > li.menu-item-has-children ul > li.menu-item-has-children ul > li a');
		$menuWrap = $('header .sub-menu-wrap');
		$subMenu = $('header .sub-menu-wrap > .sub-menu');
		$searchButton = $('button.search');
		$searchCloseButton = $('button.search-close');
		$searchWrapper = $('#site-search-input');
		$wrapperMenu = $('header nav .wrapper-menu');
		$utilityMenu = $('header nav .utility');
		$overlay = $('.menu-overlay');
		$iconMenu = $('.mobile-ham');
		$mobileMenu = $('header nav .wrapper-menu');
		$gformIntro = $('remove-gform-ajax');
		$videoOverlay = $('.wrapper--video');
		$card = $('.card');

		// Mobile Breakpoint
		$isMobileWidth = 1279;
		
		$windowWidth = $(window).width();
		
		events();

	}

	function check() {
		$windowWidth = $(window).width();
	}

	function videoPlay(wrapper) {
		var iframe = wrapper.find('.js-videoIframe');
		var src = iframe.attr('src');
		wrapper.addClass('videoWrapperActive');
		iframe.attr('src',src);
	}

	function events() {

		$(window).bind('orientationchange', check);
		$(window).resize(function() {
			check();
		}).resize();

		//
		// Wrap all button content for animation purposes
		//
		$buttons.each(function(e){
			if( $('span', this).length == 0 ) {
				$(this).wrapInner('<span></span>');
			}
		});

		// 
		// Handle Search Box
		$searchButton.on('click', function(e){
			$('.active').removeClass('active');
			$wrapperMenu.addClass('active');
			$utilityMenu.addClass('active');

			setTimeout(function() {
				$searchWrapper.addClass('active');
			}, 350);

		});
		$searchCloseButton.on('click', function(e){
			$searchWrapper.removeClass('active');

			setTimeout(function() {
				$wrapperMenu.removeClass('active');
				$utilityMenu.removeClass('active');
			}, 350);

		});

		//
		// Handle Video Interactions
		//
		$videoOverlay.each(function(e){
			$(this).on('click', function(){
				$(this).find('.overlay').toggleClass('active');
				var player = $(this).find('iframe');
				var symbol = player[0].src.indexOf("?") > -1 ? "&" : "?";
				player[0].src += symbol + "autoplay=1";
				//videoPlay(player);
			});
		});

		//
		// Handle nav clicks
		//
		if ( $windowWidth > 300 ) {

			// $('li', $subMenu).children().length
			$mainMenuLvl3Lnk.on('click', function(e){
				e.preventDefault(); // Prevent default link behavior
				var url = $(this).attr("href"); // Get the URL from the href attribute
				// Navigate to the URL
				window.location.href = url; 
			})

			$subMenu.on('click', function(e){
				e.stopPropagation();
				console.log('click');
			});

			// Top Nav Clicks/taps
			$mainMenuTopLink.on('click', function(e){
				var $this = $(this);
				var $thisSub = $(this).find('.sub-menu').first();
				var $subWrap = $('.sub-menu-wrap');
				var $sub =$('.sub-menu');

				e.preventDefault();

				if ( $(this).hasClass('active') ) {
					
					$thisSub.removeClass('active').delay(400).queue(function(add_next){
						// wait a sec...
						$this.removeClass('active');
						$utilityMenu.css('opacity', '1');
						if ( $windowWidth > $isMobileWidth ) { // handled on mobile
							$body.removeClass('active-menu');
							$('.active').removeClass('active');
						}
						$mainMenuTopLink.removeClass('inactive');
						$mainMenuTopLinkSingle.removeClass('inactive');
						
						add_next();
						
					});

				} else {
					if ( $windowWidth < $isMobileWidth ) {
						$utilityMenu.css('opacity', '0');
					}
					$mainMenuTopLink.removeClass('active');
					$subWrap.removeClass('active');
					$sub.removeClass('active');
					$body.addClass('active-menu');
					$mainMenuTopLink.addClass('inactive');
					$mainMenuTopLinkSingle.addClass('inactive');

					$this.removeClass('inactive').addClass('active').delay(500).queue(function(remove_next){
						// wait a sec...
						$thisSub.addClass('active');
						remove_next();
					});
					
				}
			});

			$mainMenuLvl2Lnk.on('click', function(e){
				var $this = $(this);
				var $thisSub = $(this).find('.sub-menu').first();
				var $allSubMenus = $(this).siblings();
				$subMenuWrap = $(this).parents('.sub-menu-wrap');
				var $sub =$('header .menu-main-nav > li.menu-item-has-children > ul > li.menu-item-has-children .sub-menu');

				e.preventDefault();

				if ( $(this).hasClass('active') ) {
					e.stopPropagation();
					$thisSub.removeClass('active').delay(500).queue(function(add_next){
						// wait a sec...
						$allSubMenus.removeClass('inactive');
						$this.removeClass('active');
						if ( $windowWidth > $isMobileWidth ) {
							$subMenuWrap.removeClass('active');
						}
						add_next();
						
					});

				} else {
					
					$mainMenuLvl2Lnk.removeClass('active');
					$sub.removeClass('active');
					$allSubMenus.addClass('inactive');

					$this.removeClass('inactive').addClass('active').delay(400).queue(function(remove_next){
						// wait a sec...
						$thisSub.addClass('active');
						if ( $windowWidth > $isMobileWidth ) {
							$subMenuWrap.addClass('active');
						}
						remove_next();
					});
					
				}

			});

		}

		//
		// Flyout nav
		//
		$iconMenu.on('click', function(e) {
			
			$body.toggleClass('active-menu');
			$overlay.toggleClass('active-menu');
			$iconMenu.toggleClass('active');
			$mobileMenu.toggleClass('active');
			$('header .wrapper-menus').toggleClass('active');
			// reset mobile nav
			if (!$body.hasClass('active-menu')) {
				$('header').find('.active').removeClass('active');
				$('header').find('.inactive').removeClass('inactive');
			}


		});


	}


		//
		// Animation Observer/Handler
		//
		
		const config = {
			root: null,
			rootMargin: '0px',
			threshold: [.3]
		};

		if ( $windowWidth < 1025 ) {
			config.threshold = [.15];
		}
		  
		let previousY = 0;
		let previousRatio = 0;
		  
		  
		let observer_animate = new IntersectionObserver( function(entries) {
			entries.forEach( entry => {

			const currentY = entry.boundingClientRect.y;
			const currentRatio = entry.intersectionRatio;
			const isIntersecting = entry.isIntersecting;
			const element = entry.target;
			
			// Scrolling up
			if ( currentY < previousY || currentRatio >= config.threshold ) {
				const className = (currentRatio >= previousRatio) ? "animated" : "outview-top";
				element.classList.add(className);
				// observer_animate.unobserve(entry.target);
			} 
			// use this if direction is both ways
			// 	// Scrolling down
			//   } else if (currentY > previousY) {
			// 	const className = (currentRatio <= previousRatio) ? "outview-bottom" : "animated";
			// 	element.classList.add(className);
			//   }
		  
			  previousY = currentY;
			  previousRatio = currentRatio;
			  
			})
		}, config);

		const animates = document.querySelectorAll('.animate');
		animates.forEach( animate => {
			observer_animate.observe(animate);
		});

		/// 
		/// Marquee Animation Observer
		///
		// const obsOptions = {
		// 	root: null,
		// 	rootMargin: '0px',
		// 	threshold: [.5]
		// }; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options
		// let isLeaving = false;
		  
		// const marquee_observer = new IntersectionObserver( function(marquee_entries) {

		// 	marquee_entries.forEach( scroll_entry => {

		// 		if ( scroll_entry.isIntersecting ) {
		// 			isLeaving = true;
		// 			scroll_entry.target.classList.add('is-inViewport');
		// 		} else if ( isLeaving ) {
		// 			isLeaving = false;
		// 			scroll_entry.target.classList.remove('is-inViewport');
		// 		}

		// 	})

		// }, obsOptions);
		  
		// Attach observer to every [data-inviewport] element:
		const Els_inViewport = document.querySelectorAll('.wrapper-scrubber');
		Els_inViewport.forEach( el => {
			// Obs.observe(EL, obsOptions);
			marquee_observer.observe(el);
		});


		

	return {
		init:init
	};

})(jQuery);
